module.exports = __webpack_public_path__ + "static/media/appucations_logo_final-retina.1bbae09f.png";


//////////////////
// WEBPACK FOOTER
// ./src/appucations_logo_final-retina.png
// module id = 336
// module chunks = 0